@if (ready && taxReturn) {
<header id="header-container" (click)="selectCategory(null, true)">
  <div id="header-details">
    <div id="header-title">
      <h4>
        <span
          [routerLink]="[
            '/',
            uiConfig?.config?.taxReturnAliasPath,
            taxReturn?.id
          ]"
        >
          &lt;&lt; {{ taxReturn?.firstName }} {{ taxReturn?.lastName }}
        </span>
        <span class="client">{{
          (taxReturn?.assignee?.populations)[0]?.client?.name
        }}</span>
      </h4>
      <div class="flex-h">
        <h1>Smart Form - {{ taxYear }} {{ smartForm?.name }}</h1>
        <div class="count-questions">
          <div class="count-circle flex-right">
            <div class="count">{{ countQuestionsInSmartForm() }}</div>
          </div>
          questions
        </div>
      </div>
    </div>
    <div id="header-notifications">
      @if (isAdmin) {
      <div style="margin-right:1em" class="empty-questions-toggle">
        <div style="flex:1"></div>
        <div
          class="ui slider checkbox"
          title="Hide questions which don't contain any answers, warnings, flags and comments"
        >
          <input [formControl]="debugModeControl" type="checkbox" />
          <label>{{ "taxReturns.debug" | transloco }}</label>
        </div>
      </div>
      }
      <span class="notification-icon documents-highlighted">
        <span class="count">{{ countDocuments(true) }}</span>
      </span>
      <span class="notification-icon warnings-highlighted">
        <span class="count">{{ activeAnsWarnings(true) }}</span>
      </span>
      <span class="notification-icon flags-highlighted">
        <span class="count">{{ activeAnsFlags(true) }}</span>
      </span>
      <span class="notification-icon comments-highlighted">
        <span class="count">{{ activeAnsComments(true) }}</span>
      </span>
      <div
        (click)="saveCheckEdits()"
        class="ui primary button"
        [ngClass]="{
          loading: isSaving,
          hidden: readonlyAlwaysEditableQuestion()
        }"
      >
        {{ "taxReturns.save" | transloco }}
      </div>
      <div
        (click)="runCalcs()"
        class="ui primary button"
        [ngClass]="{
          loading: isRunningCalcs,
          disabled:
            isSyncingAps ||
            isRunningCalcs ||
            isClearingOverrides ||
            commentFields?.length > 0 ||
            (isLodged && disableRunCalcForLodgedTaxReturn)
        }"
      >
        {{ "taxReturns.run-calcs" | transloco }}
      </div>
    </div>
  </div>
</header>
}

<hr />
@if (ready && taxReturn) {
<div class="flex-h">
  <span class="category-count">
    {{ smartForm && smartForm?.smartFormCategories.length }}
    {{ "taxReturns.category" | transloco }}</span
  >
  <div
    class="ui toggle checkbox hiddenQuestionToggle"
    (click)="toggleInactiveQuestions()"
  >
    <input
      type="checkbox"
      name="showHiddenQuestions"
      [ngModel]="showHiddenQuestions"
    />
    <label>{{ "taxReturns.Show-inactive-quesitons" | transloco }}</label>
  </div>
  <div class="smartform-builder">
    <i class="blue pen icon"></i
    ><span class="ui blue text" style="text-transform: uppercase;">{{
      "taxReturns.SMART-FORM-BUILDER" | transloco
    }}</span>
  </div>
  <div class="collapse-all" style="text-transform: uppercase;">
    <span class="ui blue text">{{
      "taxReturns.collapse-all" | transloco
    }}</span>
  </div>
  <div class="expand-all">
    <span class="ui blue text" style="text-transform: uppercase;">{{
      "taxReturns.expand-all" | transloco
    }}</span>
  </div>
</div>
}

<div #saveModal id="save-modal" class="ui tiny modal">
  <div class="modal-close close icon"></div>
  <h1>{{ "taxReturns.save" | transloco }}</h1>

  <div class="content">
    <p>
      {{
        "taxReturns.you-have-edited-fields-please-make-sure-your-comment-is-finished-before-you-save"
          | transloco
      }}
    </p>
    @for (field of commentFields; track field) {
    <div class="ui label">
      {{ field?.question }} ({{ field?.groupName }} @if (field?.groupName &&
      field?.subGroupName) {
      <span>-</span>
      }
      {{ field?.subGroupName }}@if (field?.rowIndex != null) {
      <span> - row {{ field?.rowIndex + 1 }}</span>
      })
    </div>
    }
    <textarea
      [formControl]="comment"
      id="comment-textbox"
      placeholder="Type your comment here..."
    ></textarea>
  </div>

  <div class="actions">
    <span class="go-back deny">{{ "taxReturns.no-go-back" | transloco }}</span>
    <div class="ui primary background button" (click)="save()">
      {{ "taxReturns.save-and-post" | transloco }}
    </div>
  </div>
</div>

<div #answerWarningsModal id="answer-warnings-modal" class="ui tiny modal">
  <h1>{{ "taxReturns.close-warnings" | transloco }}</h1>

  <div class="content">
    <p>
      {{
        "taxReturns.you-have-updated-answer-s-which-contain-a-warning-do-you-want-to-close-the-warning-for-the-following-answers"
          | transloco
      }}
    </p>
    <div>
      @for (ansWarning of savedAnswersWithWarnings; track ansWarning) {
      <div class="ui label">{{ ansWarning?.question }}</div>
      }
    </div>
  </div>

  <div class="actions">
    <span class="go-back cancel">{{ "taxReturns.no" | transloco }}</span>
    <div class="ui primary background approve button">
      {{ "taxReturns.yes-close-warnings" | transloco }}
    </div>
  </div>
</div>

<div #answerFlagsModal id="answer-flags-modal" class="ui tiny modal">
  <h1>{{ "taxReturns.close-flags" | transloco }}</h1>

  <div class="content">
    <p>
      {{
        "taxReturns.you-have-updated-answer-s-which-have-been-flagged-do-you-want-to-close-the-flag-for-the-following-answers"
          | transloco
      }}
    </p>
    <div>
      @for (ansFlag of savedAnswersWithFlags; track ansFlag) {
      <div class="ui label">
        {{ ansFlag.question?.question }} ({{ ansFlag.groupName }} @if
        (ansFlag.groupName && ansFlag.subGroupName) {
        <span>-</span>
        }
        {{ ansFlag.subGroupName }}@if (ansFlag.rowIndex != null) {
        <span
          >{{ "taxReturns.row" | transloco }} {{ ansFlag.rowIndex + 1 }}</span
        >
        })
      </div>
      }
    </div>
  </div>

  <div class="actions">
    <span class="go-back cancel">{{ "taxReturns.no" | transloco }}</span>
    <div class="ui primary background approve button">
      {{ "taxReturns.yes-close-flags" | transloco }}
    </div>
  </div>
</div>

<div #calcResultsModal id="calc-results-modal" class="ui tiny modal">
  @if (!isRunningCalcs) {
  <div class="modal-close close icon"></div>
  } @if (isRunningCalcs) {
  <h1>{{ "taxReturns.processing-calculation" | transloco }}</h1>
  } @if (!isRunningCalcs) {
  <h1>{{ "taxReturns.finished-calculation" | transloco }}</h1>
  }

  <div class="content">
    @for (line of calcResultsSummary; track line) {
    <p>
      {{ line }}
    </p>
    } @if (!showCalcDebug) {
    <ol>
      @for (f of calcFailures; track f) {
      <li>{{ f }}</li>
      }
    </ol>
    } @if (showCalcDebug) {
    <span>
      <table>
        <thead>
          <tr>
            <th>{{ "taxReturns.question-id" | transloco }}</th>
            <th>{{ "taxReturns.execution-time-ns" | transloco }}</th>
            <th>{{ "taxReturns.trace-time-ns" | transloco }}</th>
            <th>{{ "taxReturns.has-failed-input" | transloco }}</th>
            <th>{{ "taxReturns.skip-trace-creation" | transloco }}</th>
          </tr>
        </thead>
        <tbody>
          @for (q of calcDebug; track q) {
          <tr>
            <td>{{ q.questionId }}</td>
            <td>{{ q.exec / 1000000 | number }}</td>
            <td>{{ q.traceTime / 1000000 | number }}</td>
            <td>{{ q.failedInput }}</td>
            <td>{{ q.skipTrace }}</td>
          </tr>
          }
        </tbody>
      </table>
    </span>
    }
  </div>

  <div class="actions">
    @if (isAdmin) {
    <div class="ui primary background button" (click)="toggleCalcDebug()">
      {{ "taxReturns.toggle-calc-debug" | transloco }}
    </div>
    } @if (!isRunningCalcs) {
    <div
      class="ui primary background button approve"
      (click)="clearCalcsResults()"
    >
      {{ "taxReturns.ok" | transloco }}
    </div>
    }
  </div>
</div>

<div #unsavedFieldsModal id="unsaved-fields-modal" class="ui tiny modal">
  <div class="modal-close close icon"></div>

  <h1>{{ "taxReturns.hold-on" | transloco }}</h1>

  <div class="content">
    <p>
      {{
        "taxReturns.you-have-unsaved-changes-please-save-your-changes-before-posting-flags"
          | transloco
      }}
    </p>

    @for (field of commentFields; track field) {
    <div class="ui label">
      {{ field?.question }} ({{ field?.groupName }} @if (field?.groupName &&
      field?.subGroupName) {
      <span>-</span>
      }
      {{ field?.subGroupName }}@if (field?.rowIndex != null) {
      <span> - row {{ field?.rowIndex + 1 }}</span>
      })
    </div>
    }
  </div>

  <div class="actions">
    <div
      class="ui primary background button approve"
      [ngClass]="{ loading: isSaving }"
    >
      OK
    </div>
  </div>
</div>

<!-- page content -->
@if (ready && taxReturn) {
<div class="body-content">
  <div class="flex-v">
    @for (sfCategory of smartForm.smartFormCategories; track sfCategory) {
    <div class="category">
      <!-- category banner -->
      @if (!sfCategory.hidden || debug) {
      <div
        class="category-header row card-header no-select flex-h"
        (click)="selectCategory(sfCategory)"
        [ngClass]="sfCategory.collapsed ? '' : 'open'"
      >
        <div class="header-details flex-h">
          <i
            class="chevron icon"
            [ngClass]="{
              up: !sfCategory.collapsed,
              down: sfCategory.collapsed
            }"
          ></i>
          <h3 class="no-margin">{{ sfCategory.name }}</h3>
          @if (sfCategory.triggeringQuestionIds &&
          sfCategory.triggeringQuestionIds.length > 0) {
          <div class="condition">
            {{
              "taxReturns.displayed-as-a-result-of-answer-provided-for-question"
                | transloco
            }}
            [@for (triggeringQuestionId of sfCategory.triggeringQuestionIds;
            track triggeringQuestionId; let index = $index) {
            <a
              class="question-id"
              (click)="openQuestionInNewTab(triggeringQuestionId)"
            >
              {{ triggeringQuestionId }}@if ((index + 1) !==
              sfCategory.triggeringQuestionIds.length) {
              <span>; </span>
              }
            </a>
            } ]
          </div>
          }
        </div>
        <div class="count-circle flex-right">
          <div class="count">{{ countQuestionsInCategory(sfCategory) }}</div>
        </div>
      </div>
      }
      <!-- category content -->
      @if (!sfCategory.collapsed && (!sfCategory.hidden || debug)) {
      <div class="category-content flex-v">
        @for (sfSubCategory of sfCategory.smartFormSubCategories; track
        sfSubCategory) {
        <div>
          @if (!sfSubCategory.hidden || debug) {
          <div class="subCategory">
            <div class="subCategory-header flex-h">
              <div class="header-details flex-h">
                <span class="subcategory-name">{{ sfSubCategory.name }}</span>
                @if (sfSubCategory.triggeringQuestionIds &&
                sfSubCategory.triggeringQuestionIds.length > 0) {
                <div class="condition">
                  {{
                    "taxReturns.displayed-as-a-result-of-answer-provided-for-question"
                      | transloco
                  }}
                  [@for (triggeringQuestionId of
                  sfSubCategory.triggeringQuestionIds; track
                  triggeringQuestionId; let index = $index) {
                  <a
                    class="question-id"
                    (click)="openQuestionInNewTab(triggeringQuestionId)"
                  >
                    {{ triggeringQuestionId }}@if ((index + 1) !==
                    sfSubCategory?.triggeringQuestionIds.length) {
                    <span>; </span>
                    }
                  </a>
                  } ]
                </div>
                }
              </div>
              <div class="count-circle flex-right">
                <div class="count">
                  {{ countQuestionsInSubCategory(sfSubCategory) }}
                </div>
              </div>
            </div>
            <div class="subCategory-content">
              @for (sfQuestion of sfSubCategory.smartFormQuestions; track
              sfQuestion) {
              <div>
                @if (!sfQuestion.hidden || debug) {
                <div
                  class="sf-question"
                  [ngClass]="{
                    disabled:
                      (sfQuestion.questions[0].actualHidden ||
                        sfQuestion.hidden) &&
                      debug
                  }"
                >
                  <div class="sf-question-status-bar">{{ "" }}</div>
                  <div class="flex-h" style="margin-left: 1rem;">
                    @for (question of sfQuestion.questions; track question) {
                    <div
                      class="flex-h"
                      style="align-items: start; max-width: 60%; flex-shrink: 0; width: 50%"
                      id="{{ 'question-' + question.id }}"
                    >
                      <div>
                        @if (sfQuestion.questions[0].displayFieldType
                        ==='table') {
                        <div class="table-question-name">
                          {{ question.id }}. {{ question.question }}
                        </div>
                        } @if (sfQuestion.isOutOfSync === 1) {
                        <div class="sync-status">
                          <span class="material-icons">cloud_off</span>
                        </div>
                        } @else {
                        <div class="sync-status">
                          <span class="material-icons">cloud_done</span>
                        </div>
                        } @if (sfQuestion.questions[0].displayFieldType
                        !=='table') {
                        <div
                          (click)="
                            answerSelected(question, (sfQuestion?.answers)[0])
                          "
                          class="question-name"
                        >
                          {{ question.id }}. {{ question.question }}
                          @if (question?.showTag) {
                          <span>
                            {{ "tag" | transloco }}
                            {{ question?.showTag }})</span
                          >
                          }@if (question?.debugLinks) {
                          <span
                            >{{ "link" | transloco }}
                            <span
                              class="link"
                              (click)="goToSection('questions', question.id)"
                            >
                              {{ "question" | transloco }} </span
                            >-<span
                              class="link"
                              (click)="goToSection('calculations', question.id)"
                            >
                              {{ "calc" | transloco }} </span
                            >)</span
                          >
                          }
                        </div>
                        }
                        <div class="hint-text">
                          @if (question.hint) {
                          <div class="hint">{{ question.hint }}</div>
                          } @if (sfQuestion.triggeringQuestionIds &&
                          sfQuestion.triggeringQuestionIds.length) {
                          <div class="condition">
                            {{
                              "taxReturns.displayed-as-a-result-of-answer-provided-for-question"
                                | transloco
                            }}
                            [@for (triggeringQuestionId of
                            sfQuestion.triggeringQuestionIds; track
                            triggeringQuestionId; let index = $index) {
                            <a
                              class="question-id"
                              (click)="
                                openQuestionInNewTab(triggeringQuestionId)
                              "
                            >
                              {{ triggeringQuestionId }}@if ((index + 1) !==
                              sfQuestion?.triggeringQuestionIds.length) {
                              <span>; </span>
                              }
                            </a>
                            } ]
                          </div>
                          }
                        </div>
                      </div>
                    </div>
                    } @if (sfQuestion.questions[0].displayFieldType !=='table')
                    {
                    <div class="answer-container" style="flex-grow: 1;">
                      <app-form-field-wrapper
                        [isSmartForm]="true"
                        [subGroup]="subGroups[sfQuestion.questionId]"
                        [formGroup]="formGroup"
                        [readonly]="readonlyAlwaysEditableQuestion()"
                        [question]="sfQuestion.questions[0]"
                        [hasNotifications]="hasNotification"
                        [showHiddenQuestion]="true"
                        [hideClearOverRideQuestionIcon]="hideOverrideIcon()"
                        [disabled]="
                          isQuestionAlwaysEditable(
                            question,
                            readonly || deleted || undefined
                          )
                        "
                        (refreshTaxReturn)="refreshSmartForm.emit(true)"
                        [inputQuestionId]="inputQuestionId"
                      ></app-form-field-wrapper>
                      @if (sfQuestion.questions[0].displayFieldType !=='table')
                      {
                      <div class="dots">
                        @if (hasNotification('answerWarnings',
                        sfQuestion.questions[0], sfQuestion?.answers[0])) {
                        <div
                          class="dot warning"
                          [ngClass]="{
                            active: hasNotification(
                              'answerWarnings',
                              sfQuestion.questions[0],
                              (sfQuestion?.answers)[0],
                              true
                            )
                          }"
                        ></div>
                        } @if (hasNotification('answerFlags',
                        sfQuestion.questions[0], sfQuestion?.answers[0])) {
                        <div
                          class="dot flag"
                          [ngClass]="{
                            active: hasNotification(
                              'answerFlags',
                              sfQuestion.questions[0],
                              (sfQuestion?.answers)[0],
                              true
                            )
                          }"
                        ></div>
                        } @if (hasNotification('comments',
                        sfQuestion.questions[0], sfQuestion?.answers[0])) {
                        <div class="dot comment"></div>
                        }
                      </div>
                      }
                    </div>
                    }
                  </div>
                  @if (sfQuestion.questions[0].displayFieldType === 'table') {
                  <div>
                    <!-- TODO: finish implementing modern table as it is used in question-group-card -->
                    <!-- Still needs all of the input parameters to be defined/ updated and any functions or output emit called to be defined -->
                    <app-smart-form-view-table
                      [subGroup]="subGroups[sfQuestion.questionId]"
                      [formGroup]="formGroup"
                      [readonly]="readonlyAlwaysEditableQuestion()"
                      [question]="
                        taxReturn.questionsById[sfQuestion.questionId]
                      "
                      [hasNotifications]="hasNotification"
                      [showHiddenQuestion]="true"
                      [hideClearOverRideQuestionIcon]="hideOverrideIcon()"
                      [disabled]="
                        isQuestionAlwaysEditable(
                          question,
                          readonly || deleted || undefined
                        )
                      "
                      (refreshTaxReturn)="refreshSmartForm.emit(true)"
                      [inputQuestionId]="inputQuestionId"
                      [isFullScreenMode]="isFullScreenMode"
                      (toggleFullScreen)="handleToggleFullScreen($event)"
                      [debugMode]="debug"
                      (loadTrace)="loadTrace($event)"
                      [inspectMode]="
                        (tab == 3 && 'flag') ||
                        (rightSideTab == 'calculation' && 'trace') ||
                        null
                      "
                    ></app-smart-form-view-table>
                  </div>
                  }
                </div>
                }
              </div>
              }
            </div>
          </div>
          }
        </div>
        }
      </div>
      }
    </div>
    }
  </div>
  <aside class="subcategory-right-panel" [ngClass]="{ closed: !sideOpen }">
    <i
      class="toggle-side chevron icon"
      [ngClass]="{ right: sideOpen, left: !sideOpen }"
      (click)="handleSideOpen()"
    ></i>
    <div class="right-side-tab-selector">
      <div
        class="right-side-tab"
        [ngClass]="{ active: rightSideTab == 'activity' }"
        (click)="rightSideTab = 'activity'; countWarningsFlagsComments()"
      >
        {{ "taxReturns.activity" | transloco }}
      </div>
      <div
        class="right-side-tab"
        [ngClass]="{ active: rightSideTab == 'calculation' }"
        (click)="rightSideTab = 'calculation'"
      >
        {{ "taxReturns.calculation" | transloco }}
      </div>
    </div>
    @if (rightSideTab == 'calculation' && traceQuestion) {
    <h3 class="calculation-header">
      @if (showQuestionId) {
      <span>{{ traceQuestion?.id }}.</span>
      } {{ traceQuestion.question }}
    </h3>
    } @if (rightSideTab == 'calculation') {
    <div class="tab-content calculation-tab">
      @if (loadingTrace) {
      <div class="ui active centered inline loader"></div>
      } @if (!loadingTrace && !traceQuestion) {
      <div class="trace-message">
        {{
          "taxReturns.click-a-question-label-or-table-cell-to-view-how-an-answer-was-calculated"
            | transloco
        }}
      </div>
      }
      <app-answer-trace
        [trace]="trace"
        [question]="traceQuestion"
        [answer]="traceAnswer"
        [taxReturn]="taxReturn"
        [subCategory]="subCategory"
      ></app-answer-trace>
    </div>
    } @if (rightSideTab == 'activity') {
    <div class="tab-content activity-tab">
      <div id="notifications">
        <h3 id="title">
          {{ title() }}
        </h3>
        <div id="icons">
          <div
            (click)="filterDocuments(); selectTab(4)"
            class="notification-icon documents-highlighted"
            [ngClass]="{ active: tab == 4 }"
          >
            <span class="count">{{ countDocuments() }}</span>
          </div>
          <div
            (click)="initWarnings(); selectTab(1)"
            class="notification-icon warnings-highlighted"
            [ngClass]="{ active: tab == 1 }"
          >
            <span class="count">{{ activeAnsWarnings() }}</span>
          </div>
          <div
            (click)="initFlagsTab(); initFlags(); selectTab(3)"
            class="notification-icon flags-highlighted"
            [ngClass]="{ active: tab == 3 }"
          >
            <span class="count">{{ activeAnsFlags() }}</span>
          </div>
          <div
            (click)="selectTab(2)"
            class="notification-icon comments-highlighted"
            [ngClass]="{ active: tab == 2 }"
          >
            <span class="count">{{ totalComments }}</span>
          </div>
        </div>
      </div>
      @if (tab === 1) {
      <div id="warnings-tab">
        <div class="list-container">
          <div style="flex:1"></div>
          @for (answerWarning of answerWarnings; track answerWarning) {
          <div>
            <div
              class="warning"
              [ngClass]="{ disabled: answerWarning?.status !== 0 }"
            >
              <div class="header">
                <div class="warning-type">
                  <div class="ui orange label">
                    {{ "taxReturns.review" | transloco }}
                  </div>
                  {{ answerWarning?.warning?.message }}
                </div>
                <div class="warning-date">
                  {{ answerWarning?.createdAtString }}
                </div>
              </div>
              <div class="labels">
                <span class="ui label"
                  >@if (showQuestionId) {
                  <span>{{ answerWarning?.questionId }}.</span>
                  }
                  {{ answerWarning?.question }} @if (answerWarning?.rowIndex) {
                  <span> (row - {{ answerWarning?.rowIndex }})</span>
                  }</span
                >
              </div>
              <pre class="warning-message">{{
                answerWarning?.warningMessage
              }}</pre>
              @if (answerWarning.replies.length > maxNumOfComments) {
              <div class="buttons">
                <div
                  (click)="
                    answerWarning.isCollapsed = !answerWarning.isCollapsed
                  "
                  class="respond"
                >
                  {{ answerWarning.isCollapsed ? "Expand" : "Collapse" }}
                </div>
              </div>
              } @for (comment of
              answerWarning.replies.slice(answerWarning.isCollapsed ? -1 : 0);
              track comment; let i = $index) {
              <div class="comment">
                <div class="commenter-name">{{ comment?.author }}</div>
                <div class="commenter-role">
                  <div>
                    <i
                      class="small circle icon"
                      [ngClass]="{
                        preparer: comment?.role === 'Preparer',
                        reviewer: comment?.role === 'Reviewer'
                      }"
                    ></i>
                    {{ comment?.role }}
                  </div>
                  <div class="comment-date">{{ comment?.date }}</div>
                </div>
                <div class="comment-text">
                  <app-comment
                    [comment]="comment"
                    [documents]="taxReturn.documents"
                  ></app-comment>
                </div>
              </div>
              }
              <div class="reply-comment">
                @if (answerWarning?.replyTo) {
                <div>
                  <textarea
                    [(ngModel)]="answerWarning.replyComment"
                    placeholder="Type your comment here..."
                  ></textarea>
                  <span
                    (click)="
                      answerWarning.replyTo = false;
                      answerWarning.replyComment = ''
                    "
                    class="cancel-reply"
                    >{{ "taxReturns.cancel" | transloco }}</span
                  >
                  <span
                    (click)="
                      saveAnsWarningReply(
                        answerWarning,
                        answerWarning.replyComment
                      )
                    "
                    class="reply-only"
                    [ngClass]="{
                      disabled: !answerWarning.replyComment || replyingWarning
                    }"
                    >{{ "taxReturns.reply-only" | transloco }}</span
                  >
                  <div
                    (click)="
                      saveAnsWarningReply(
                        answerWarning,
                        answerWarning.replyComment,
                        true
                      )
                    "
                    class="ui primary background button"
                    [ngClass]="{
                      disabled: !answerWarning.replyComment || replyingWarning
                    }"
                  >
                    {{ "taxReturns.reply-and-close" | transloco }}
                  </div>
                </div>
                } @if (answerWarning?.replyToClient) {
                <div>
                  <textarea
                    [(ngModel)]="answerWarning.replyClient"
                    placeholder="Type your comment here..."
                  ></textarea>
                  <span
                    (click)="
                      answerWarning.replyToClient = false;
                      answerWarning.replyClient = ''
                    "
                    class="cancel-reply"
                    >{{ "taxReturns.cancel" | transloco }}</span
                  >
                  <div
                    (click)="
                      sendAnsWarningReplyToClient(
                        answerWarning,
                        answerWarning.replyClient
                      )
                    "
                    class="ui primary background button"
                    [ngClass]="{
                      disabled: !answerWarning.replyClient || replyingWarning
                    }"
                  >
                    {{ "taxReturns.post" | transloco }}
                  </div>
                </div>
                }
              </div>
              <div class="buttons">
                @if (answerWarning?.status == 0 && !answerWarning?.replyTo &&
                !readonlyAlwaysEditableQuestion()) {
                <div (click)="answerWarning.replyTo = true" class="respond">
                  {{ "taxReturns.reply" | transloco }}
                </div>
                } @if (showSendToClientButton(answerWarning)) {
                <div
                  class="send-to-client"
                  (click)="
                    validateBatchMembership(answerWarning, taxReturn, true)
                  "
                >
                  <i class="arrow up icon"></i>
                  <span *transloco="let t">{{
                    answerWarning.externalUrl
                      ? t("taxReturns.Reply-to-Client")
                      : t("taxReturns.Send-to-Client")
                  }}</span>
                </div>
                } @if (answerWarning.externalUrl) {
                <div class="view-in-oneteam">
                  <i class="external alternate icon"></i>
                  <a [href]="answerWarning.externalUrl" target="_blank">{{
                    "taxReturns.View-in-OneTeam" | transloco
                  }}</a>
                </div>
                }
              </div>
            </div>
          </div>
          }
          <ng-template #criticalWarning let-warnings="warnings">
            @for (warning of warnings; track warning) {
            <div>
              <div class="warning">
                <div class="header">
                  <div class="warning-type">
                    <div class="ui red label">
                      {{ "taxReturns.critical" | transloco }}
                    </div>
                    {{ warning?.warningMessage }}
                  </div>
                  <div class="warning-date">{{ warning?.createdAtString }}</div>
                </div>
                <div class="labels">
                  <span class="ui label"
                    >@if (showQuestionId) {
                    <span>{{ warning?.id }}.</span>
                    }
                    {{ warning?.question }}</span
                  >
                </div>
              </div>
            </div>
            }
          </ng-template>
          @if (validationWarnings.length) {
          <ng-container
            *ngTemplateOutlet="
              criticalWarning;
              context: { warnings: validationWarnings }
            "
          >
          </ng-container>
          }
        </div>
      </div>
      } @if (tab === 3) {
      <div id="flags-tab">
        <div class="list-container">
          <div style="flex:1"></div>
          @for (answerFlag of answerFlags|orderBy:['createdAt']:['asc']; track
          answerFlag) {
          <div class="flag" [ngClass]="{ disabled: answerFlag?.status > 0 }">
            <div class="comment">
              <div class="header">
                <div class="ui label">
                  {{ answerFlag.flag.flagMessage }}
                </div>
                <div class="commenter-name">
                  {{ answerFlag?.parentComment?.author }}
                </div>
                <div class="date">{{ answerFlag?.parentComment?.date }}</div>
              </div>
              <div class="commenter-role">
                <div>
                  <i
                    class="small circle icon"
                    [ngClass]="{
                      preparer: answerFlag?.parentComment?.role === 'Preparer',
                      reviewer: answerFlag?.parentComment?.role === 'Reviewer'
                    }"
                  ></i>
                  {{ answerFlag?.parentComment?.role }}
                </div>
                <div class="comment-date">
                  {{ answerFlag?.parentComment?.createdAtString }}
                </div>
              </div>
              <div class="labels">
                <span class="ui label"
                  >@if (showQuestionId) {
                  <span>{{ answerFlag?.question?.id }}.</span>
                  }
                  {{ answerFlag?.question?.question }} @if
                  (answerFlag?.rowIndex) {
                  <span> (row - {{ answerFlag?.rowIndex }})</span>
                  }</span
                >
              </div>
              @if (answerFlag.parentComment) {
              <div class="comment-text">
                <app-comment
                  [comment]="answerFlag.parentComment"
                  [documents]="taxReturn.documents"
                ></app-comment>
              </div>
              } @if (answerFlag?.parentComment?.comments.length >
              maxNumOfComments) {
              <div class="buttons">
                <div
                  (click)="answerFlag.isCollapsed = !answerFlag.isCollapsed"
                  class="respond"
                >
                  {{ answerFlag.isCollapsed ? "Expand" : "Collapse" }}
                </div>
              </div>
              } @for (comment of
              answerFlag?.parentComment?.comments.slice(answerFlag.isCollapsed ?
              -1 : 0); track comment; let i = $index) {
              <div class="reply comment">
                <div class="header">
                  <div class="commenter-name">{{ comment?.author }}</div>
                  <div class="date">{{ comment?.date }}</div>
                </div>
                <div class="commenter-role">
                  <div>
                    <i
                      class="small circle icon"
                      [ngClass]="{
                        preparer: comment?.role === 'Preparer',
                        reviewer: comment?.role === 'Reviewer'
                      }"
                    ></i>
                    {{ comment?.role }}
                  </div>
                </div>
                <div class="comment-text">
                  <app-comment
                    [comment]="comment"
                    [documents]="taxReturn.documents"
                  ></app-comment>
                </div>
              </div>
              }
              <div class="reply-comment">
                @if (!readonlyAlwaysEditableQuestion() && answerFlag.replyTo) {
                <div>
                  <textarea
                    [(ngModel)]="answerFlag.replyComment"
                    placeholder="Type your comment here..."
                  ></textarea>
                  <span
                    (click)="
                      answerFlag.replyTo = false; answerFlag.replyComment = ''
                    "
                    class="cancel-reply"
                    >{{ "taxReturns.cancel" | transloco }}</span
                  >
                  <span
                    (click)="replyToFlag(answerFlag)"
                    class="reply-only"
                    [ngClass]="{
                      disabled: !answerFlag.replyComment || replyingFlag
                    }"
                    >{{ "taxReturns.reply-only" | transloco }}</span
                  >
                  <div
                    (click)="replyToFlag(answerFlag, true)"
                    class="ui primary background button"
                    [ngClass]="{
                      disabled: !answerFlag.replyComment || replyingFlag
                    }"
                  >
                    {{ "taxReturns.reply-and-close" | transloco }}
                  </div>
                </div>
                } @if (!readonlyAlwaysEditableQuestion() &&
                answerFlag.replyToClient) {
                <div>
                  <textarea
                    [(ngModel)]="answerFlag.replyClient"
                    placeholder="Type your comment here..."
                  ></textarea>
                  <span
                    (click)="
                      answerFlag.replyToClient = false;
                      answerFlag.replyClient = ''
                    "
                    class="cancel-reply"
                    >{{ "taxReturns.cancel" | transloco }}</span
                  >
                  <span
                    (click)="
                      sendAnsFlagReplyToClient(
                        answerFlag,
                        answerFlag.replyClient,
                        answerFlag?.question?.id
                      )
                    "
                    class="ui primary background button"
                    [ngClass]="{
                      disabled: !answerFlag.replyClient || replyingFlag
                    }"
                    >{{ "taxReturns.post" | transloco }}</span
                  >
                </div>
                }
              </div>
            </div>
            <div class="buttons">
              @if (!readonlyAlwaysEditableQuestion() && answerFlag?.status === 0
              && !answerFlag.replyTo) {
              <span (click)="answerFlag.replyTo = true" class="respond">{{
                "taxReturns.reply" | transloco
              }}</span>
              } @if (showSendToClientButton(answerFlag)) {
              <div
                class="send-to-client"
                (click)="validateBatchMembership(answerFlag, taxReturn, false)"
              >
                <i class="arrow up icon"></i>
                <span *transloco="let t">{{
                  answerFlag.externalUrl
                    ? t("taxReturns.Reply-to-Client")
                    : t("taxReturns.Send-to-Client")
                }}</span>
              </div>
              } @if (answerFlag.externalUrl) {
              <div class="view-in-oneteam">
                <i class="external alternate icon"></i>
                <a [href]="answerFlag.externalUrl" target="_blank">{{
                  "taxReturns.View-in-OneTeam" | transloco
                }}</a>
              </div>
              }
            </div>
          </div>
          }
          <div class="scroll-anchor"></div>
        </div>
        <div [hidden]="!flaggedAns" class="textbox-container">
          <div class="fields-title">
            <div class="label">
              {{ "taxReturns.flagged-fields" | transloco }}
            </div>
            <div class="line"></div>
          </div>
          <div class="fields-container">
            <div class="ui label">
              @if (showQuestionId) {
              <span>{{ flaggedAns?.id }}.</span>
              } {{ flaggedAns?.question }}
              @if (flaggedAns?.subGroupName) {
              <span
                >({{ flaggedAns?.subGroupName }}@if (flaggedAns?.rowIndex !=
                null) {
                <span
                  >{{ "taxReturns.row" | transloco }}
                  {{ flaggedAns?.rowIndex + 1 }}</span
                >
                })</span
              >
              }
              <i
                (click)="unFlagAns(flaggedAns)"
                class="close icon"
                title="Click to un-flag answer"
              ></i>
            </div>
          </div>
          <textarea
            [formControl]="flagsComment"
            id="flags-textbox"
            placeholder="Type your comment here..."
          ></textarea>
          <div style="display:flex">
            <div #flagDropDown class="ui search selection dropdown">
              <input class="search" autocomplete="off" />
              <div class="text"></div>
              <div class="menu"></div>
              <i class="chevron down icon"></i>
            </div>
            @if (!readonlyAlwaysEditableQuestion()) {
            <div
              (click)="saveAnsFlag()"
              id="save-ans-flags"
              class="ui primary background button"
              [ngClass]="{
                disabled: !flagsComment.value || !flagTypeId || isSaving,
                loading: isSaving
              }"
              [title]="
                !flagsComment.value ? 'You must provide a comment' : undefined
              "
            >
              {{ "taxReturns.post-flag" | transloco }}
            </div>
            }
          </div>
        </div>
      </div>
      } @if (tab === 4) {
      <div id="documents-tab">
        @if (filteredDocuments.length === 0) {
        <span class="no-docs">{{
          "taxReturns.no-documents-links-found" | transloco
        }}</span>
        }
        <ol>
          @for (doc of filteredDocuments; track doc) {
          <li>
            <a [href]="doc.url | KExplorer" target="_blank" rel="noreferrer">{{
              doc.filename || doc.url
            }}</a>
          </li>
          }
        </ol>
      </div>
      } @if (tab === 2 && getCommentMeta) {
      <app-comments
        [comment]="comment"
        (commentSave)="saveComment($event)"
        (commentReply)="updateCommentsCount($event)"
        (totalComments)="updateGroupCommentsCount($event)"
        [documents]="taxReturn.documents"
        [isSaving]="isSaving"
        [commentFields]="commentFields"
        [getCommentMeta]="getCommentMeta"
        [handleCommentReply]="handleCommentReply"
        [readonly]="readonlyAlwaysEditableQuestion()"
        [pastedDocMetadatas]="commentDocumentMetadatas"
        (deleteCommentField)="deleteCommentField($event)"
        [isSmartForm]="true"
        [activeCategory]="activeCategory"
        [smarFormWithCount]="smarFormWithCount"
        [hiddenAndMandatoryMap]="hiddenAndMandatoryMap"
      >
      </app-comments>
      }
    </div>
    }
  </aside>
</div>
}

<!-- </div> -->

@if (!(ready && taxReturn)) {
<div class="ui active inverted dimmer" [ngClass]="{ dimmed: !firstLoad }">
  <div class="ui large text loader">{{ "taxReturns.loading" | transloco }}</div>
</div>
}
